import { NO_URL } from '../../constants/Constants';
import { TranslationKeys } from '../../types/Translations.type';
import { ShowpadLinkHelper } from '../../helpers/ShowpadLinkHelper';
import { interpolateUrlVariables } from '../../helpers/UrlHelper';
import { ViewerUrlAssetClickedEvent } from '../../types/ViewerEvents.type';
import { AssetViewerViewMapper } from '../../helpers/AssetViewerViewMapper';
export class UrlPresentationRenderer {
    constructor(assetViewerView, presentation) {
        this.assetViewerView = assetViewerView;
        this.presentation = presentation;
        this.hasMetaData = true;
        this.isLoading = false;
        this.isActive = false;
        this.height = null;
        this.container = null;
        this.containerContent = null;
    }
    get config() {
        return this.assetViewerView.config;
    }
    get translations() {
        return this.config.TRANSLATIONS;
    }
    get url() {
        const url = this.checkUrl(this.presentation);
        if (!url || (url && url.toLowerCase().indexOf('javascript') === 0)) {
            return NO_URL;
        }
        else if (!/^(.*:\/\/)/.test(url) && url.toLowerCase().indexOf('mailto:') !== 0) {
            return `http://${interpolateUrlVariables(url, this.config)}`;
        }
        else {
            return interpolateUrlVariables(url, this.config);
        }
    }
    get previewUrl() {
        return this.assetViewerView.assetViewerItem.previewUrl;
    }
    get name() {
        const splitUrl = this.assetViewerView.assetViewerItem.displayName.split('.url');
        return splitUrl.length === 2 && splitUrl[1] === '' ? splitUrl[0] : this.assetViewerView.assetViewerItem.displayName;
    }
    get dimensions() {
        if (!this.height) {
            return null;
        }
        const { config } = this.assetViewerView;
        const extraSpace = config.VIEW_PADDING_TOP + config.VIEW_PADDING_BOTTOM + 2 * config.VIEW_BORDER;
        return {
            width: Math.min(config.MAX_CONTENT_WIDTH, this.assetViewerView.viewerLayout.viewportWidth - extraSpace),
            height: this.height
        };
    }
    checkUrl(presentation) {
        if (!!presentation.url) {
            return presentation.url;
        }
        else if (!!presentation.urls) {
            return presentation.urls[0];
        }
        else {
            return null;
        }
    }
    load() {
        return Promise.resolve();
    }
    render(container) {
        this.container = container;
        return Promise.resolve().then(() => {
            const urlWrapper = document.createElement('div');
            this.containerContent = urlWrapper;
            urlWrapper.classList.add('renderer-url');
            const link = document.createElement('a');
            link.classList.add('link');
            if (this.url !== NO_URL) {
                link.href = this.url;
                if (ShowpadLinkHelper.isShowpadLink(this.url)) {
                    link.onclick = () => {
                        // prevent postMessage being fired twice when showpad-js-web is loaded on the page
                        if (!(typeof window !== 'undefined' && window.ShowpadLib)) {
                            ShowpadLinkHelper.handleShowpadAssetLink({
                                target: link.target,
                                uri: link.href
                            });
                        }
                    };
                }
                else {
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    link.onclick = () => {
                        this.assetViewerView.eventBus.dispatch(new ViewerUrlAssetClickedEvent({
                            assetViewerView: AssetViewerViewMapper.mapToPublicAssetViewerView(this.assetViewerView)
                        }));
                    };
                }
            }
            const urlInfoWrapper = document.createElement('div');
            urlInfoWrapper.classList.add('info-wrapper');
            const urlInfo = document.createElement('div');
            urlInfo.classList.add('info');
            const urlName = document.createElement('div');
            urlName.classList.add('name');
            urlName.innerText = this.name;
            urlInfo.appendChild(urlName);
            const linkPreviewWrapper = document.createElement('div');
            linkPreviewWrapper.classList.add('link-preview-wrapper');
            const previewImageWrapper = document.createElement('div');
            previewImageWrapper.classList.add('link-preview');
            previewImageWrapper.innerHTML = `<img src="${this.previewUrl}" alt="${this.translations[TranslationKeys.PreviewImage]}"/>`;
            if (this.assetViewerView.assetViewerItem.assetDescription) {
                const linkDescription = document.createElement('div');
                linkDescription.classList.add('link-description');
                linkDescription.innerText = this.assetViewerView.assetViewerItem.assetDescription;
                urlInfo.appendChild(linkDescription);
            }
            link.innerHTML = ` ${this.translations[TranslationKeys.VisitUrl]}`;
            urlInfo.appendChild(link);
            container.appendChild(urlWrapper);
            linkPreviewWrapper.appendChild(previewImageWrapper);
            urlInfoWrapper.appendChild(linkPreviewWrapper);
            urlInfoWrapper.appendChild(urlInfo);
            urlWrapper.appendChild(urlInfoWrapper);
            this.container.appendChild(urlWrapper);
            // calculate height based on the DOM element after it has been added to the DOM
            this.height = this.containerContent.offsetHeight;
        });
    }
    resize() {
        if (this.height && this.containerContent) {
            this.height = this.containerContent.offsetHeight;
        }
    }
    destroy() {
        if (this.container) {
            this.container.innerHTML = '';
            this.container = null;
        }
    }
    destroyFinal() {
        this.destroy();
    }
}
//# sourceMappingURL=UrlPresentationRenderer.js.map